export const endpointName = 'Justification';
export const createJustificationEndpoint = 'Justification';
export const getJustificationEndpoint = 'Justification';
export const updateJustificationEndpoint = 'Justification/Update';
export const deleteJustificationEndpoint = 'Justification/Delete';
